module.exports = __webpack_public_path__ + "static/media/blood-orange-2.b98ad372.png";